import { render, staticRenderFns } from "./PorAcs.vue?vue&type=template&id=0e80bf3e&scoped=true"
import script from "./PorAcs.vue?vue&type=script&lang=js"
export * from "./PorAcs.vue?vue&type=script&lang=js"
import style0 from "./PorAcs.vue?vue&type=style&index=0&id=0e80bf3e&prod&lang=css"
import style1 from "./styles.scss?vue&type=style&index=1&id=0e80bf3e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80bf3e",
  null
  
)

export default component.exports